<template>
  <el-select v-model="model" @change="emitInput" :multiple="multiple" filterable clearable remote :placeholder="placeholder" :remote-method="remoteMethod" :loading="loading">
    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
  </el-select>
</template>

<script>
export default {
  name: "remote-select",
  props: {
    value: {
      type: [String, Array],
      default: function() {
        if (this.multiple) {
          return [];
        } else {
          return null
        }
      }
    },
    placeholder: {
      type: String,
      default: function() {
        return "Search";
      }
    },
    fetch: {
      type: Function,
      default: function() {
        return query => Promise.resolve([...this.defaultOptions]);
      }
    },
    multiple: {
      type: Boolean,
      default: function() {
        return false
      }
    },
    defaultOptions: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data() {
    return {
      model: null,
      loading: false,
      options: []
    };
  },
  watch: {
    value: function(newVal) {
      this.model = newVal
    }
  },
  methods: {
    emitInput(event) {
      this.$emit("input", this.model);
    },
    async remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        this.options = await this.fetch(query);
        this.loading = false;
      } else {
        this.loading = false;
        this.options = [...this.defaultOptions];
      }
    }
  },
  created() {
    this.options = [...this.defaultOptions];
  }
};
</script>
